export default __webpack_public_path__ + "static/students-2-2258b54d64516c00c5cb0aa8cb116741.jpg";